import styled from 'styled-components';
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';
import Throbber from '@ertelecom/ui-react/components/throbber/throbber';

export const Preloader = styled(Throbber)`
    position: absolute;
    width: 100px;
    height: 100px;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    margin: auto;
    transform: translate(0, 0);
`;

export const Content = styled.div`
    display: block;
    position: relative;
    width: 100%;
    margin-bottom: -50px;
    padding-top: 12px;
    padding-bottom: 60px;
    background-color: ${COLORS.white};
    overflow: hidden;
`;

export const InnerWrap = styled.div`
    max-width: 1440px;
    margin-left: auto;
    margin-right: auto;
    padding: 0 8%;

    @media screen and (max-width: 1188px) {
        padding: 0 5%;
    }
`;

export const Title = styled.h1`
    margin-bottom: 40px;
    width: 100%;
`;

export const DateFilters = styled.div`
    justify-content: space-between;
    width: 338px;
    margin-bottom: 30px;

    @media screen and (max-width: 380px) {
        flex-direction: column;
        width: 100%;
        height: 110px;
    }
`;

export const TagsWrap = styled.div`
    margin-bottom: 40px;
`;

export const List = styled.ul`
    display: flex;
    flex-wrap: wrap;
    padding-left: 0;
    list-style: none;
`;

export const ListItem = styled.li`
    width: 32%;
    margin-right: 2%;
    margin-bottom: 60px;

    &:first-child {
        width: 100%;
        margin-right: 0;
    }

    &:nth-child(3n + 4) {
        margin-right: 0;
    }

    @media screen and (max-width: 1024px) {
        margin-bottom: 40px;
        width: 49%;
        margin-right: 2%!important;

        &:first-child {
            margin-right: 0!important;
        }

        &:nth-child(2n+3) {
            margin-right: 0!important;
        }
    }

    @media screen and (max-width: 580px) {
        width: 100%;
        margin-right: 0!important;
    }
`;

export const PaginationWrap = styled.div`
    width: 100%;
    justify-content: center;
`;
